<template>
  <div class="box">
    <div class="Overall-satisfaction">
      <span class="left">总体满意度</span>
      <div class="right">
        <img v-if="overallSatisfaction === '不满意'" src="../../../../assets/refund/bumanyi.png" alt="">
        <img v-if="overallSatisfaction === '满意'" src="../../../../assets/refund/manyi.png" alt="">
        <img v-if="overallSatisfaction === '基本满意'" src="../../../../assets/refund/jibenmanyi.png" alt="">
        <span>{{ overallSatisfaction }}</span>
        <!-- <img v-if="totalSatisfaction && totalSatisfaction.grade == 1" src="../../../../assets/refund/bumanyi.png" alt="">
        <img v-if="totalSatisfaction && totalSatisfaction.grade == 5" src="../../../../assets/refund/manyi.png" alt="">
        <img v-if="totalSatisfaction && totalSatisfaction.grade == 3" src="../../../../assets/refund/jibenmanyi.png" alt="">
        <span v-if="totalSatisfaction && totalSatisfaction.grade">{{ getSatisfaction(totalSatisfaction.grade) || '无'}}</span> -->
      </div>
    </div>

    <div class="Satisfaction-list">
      <div v-for="(i, index) in evaluationList" :key="index" class="Satisfaction-item">
        <span class="name">{{ i.targetName || '无'}}</span>
        <span class="grade">{{ getSatisfaction(i.grade) }}</span>
      </div>
    </div>

    <p class="title">评价补充</p>
    <p class="content">{{ totalSatisfaction.comment || '无' }}</p>
    <p class="title">评价时间</p>
    <p v-if="totalSatisfaction && totalSatisfaction.createTime" class="content">{{ totalSatisfaction.createTime | timeformat }}</p>
  </div>
</template>

<script>
    import common from '../../../../utils/common'
    import api from '../../../../service/modules/refund'

    export default {
        filters: {
            timeformat (val) {
                return common.getStampInDate(val, '/')
            }
        },
        data () {
            return {
                evaluationList: [],
                totalSatisfaction: {}, // 总体满意度
                flowId: '',
                overallSatisfaction: '' // 总体满意度
            }
        },
        created () {
            try {
                this.flowId = this.$route.query.flowId
                this.getDetail()
            } catch (err) {
            }
        },
        methods: {
            getDetail () {
                try {
                    api.detailList({ flowId: this.flowId }).then(res => {
                        if (res.ret === 0) {
                            this.evaluationList = res.data.evaluations
                            console.log('详情', this.evaluationList)
                            let totalScore = 0
                            if (this.evaluationList.length > 0) {
                                this.evaluationList.map(i => {
                                    totalScore += i.grade
                                })
                                if (this.evaluationList.length === 1) {
                                    this.totalSatisfaction = this.evaluationList[0]
                                } else {
                                    // 取targetType为1作为总评价
                                    this.evaluationList.map((i, index) => {
                                        if (i.targetType == 1) {
                                            this.totalSatisfaction = this.evaluationList.splice(index, 1)[0]
                                        }
                                    })
                                }
                            }
                            const average = totalScore / this.evaluationList.length
                            if (average > 0 && average <= 3) {
                                this.overallSatisfaction = '不满意'
                            } else if (average > 3 && average < 5) {
                                this.overallSatisfaction = '基本满意'
                            } else {
                                this.overallSatisfaction = '满意'
                            }
                            console.log(this.overallSatisfaction, 'overallSatisfaction')
                        } else {
                            this.evaluationList = []
                        }
                    })
                } catch (err) {
                }
            },
            getSatisfaction (val) {
                const option = {
                    1: '不满意',
                    3: '基本满意',
                    5: '满意'
                }
                return option[val] || '无'
            }
        }
    }
</script>

<style lang="less" scoped>
  .box {
    padding: 33px 16px 0;
    .Overall-satisfaction {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 14px;
      .left {
        font-weight: Medium;
        font-size: 16px;
        color: #333333;
      }
      .right {
        display: flex;
        align-items: center;
        img {
          width: 25px;
          height: 25px;
          margin-right: 6px;
        }
        span {
          font-size: 14px;
          color: #1E2226;
        }
      }

    }

    .Satisfaction-list {
      background: #F9FAFC;
      border-radius: 4px;
      padding: 16px;
      margin-bottom: 26px;
      .Satisfaction-item {
        display: flex;
        justify-content: space-between;
        line-height: 22px;
        &:not(:last-child) {
          margin-bottom: 8px;
        }
        .name {
          font-size: 14px;
          color: #71747A;
          font-weight: 400;
        }
        .grade {
          font-size: 14px;
          color: #1E2226;
          font-weight: 400;
        }
      }
    }
    .title {
      font-weight: 500;
      font-weight: Medium;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      margin-bottom: 8px;
    }
    .content {
      font-size: 14px;
      color: #71747A;
      font-weight: 400;
      line-height: 22px;
      margin-bottom: 24px;
    }
  }
</style>
